<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <p style="font-size: large">{{ company }}</p>
          <p style="font-size: xx-small;margin-top: 5px">{{company_short}}</p>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
<!--          <el-menu-item index="/news">新闻资讯</el-menu-item>-->
          <el-menu-item index="/weight-loss">减肥课堂</el-menu-item>
          <el-menu-item index="/product-intro">产品展示</el-menu-item>
<!--          <el-menu-item index="/goin">走进{{ company_short }}</el-menu-item>-->
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进{{ company_short }}</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>产品展示</span>
              <span>产品介绍</span>
            </li>
            <li>
              <p>联系我们</p>
<!--              <span>邮箱：{{ companyConfig.email }}</span>-->
              <span>地址：{{ companyConfig.address }}</span>
            </li>
          </ul>
<!--          <img src="https://mp.weixin.qq.com/mp/qrcode?scene=10000004&size=102&__biz=MzkwOTIyMTIzNg==&mid=2247488605&idx=1&sn=b0faddb57f305d99b39330f6b7472aac&send_time=" alt />-->
        </div>
        <footer style="align-content: center;text-align: center;padding-bottom: 3px;">
          <p style="color: #cde; font-size: 12px; margin-bottom: 4px;">药品、医疗器械互联网信息服务备案：{{ companyConfig.medical_record_code }}</p>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white">{{ companyConfig.record_code }}</a>
        </footer>
      </div>

    </el-container>
  </div>
</template>

<script>
import { companyConfig } from './config/companyConfig';

export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: true,
      companyConfig
    };
  },
  created() {
    console.log(companyConfig)
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0;
}

.footer {
  z-index: 100000;
  width: 100%;
  height: 240px;
  //overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 2px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
